import { TipoCambioSUNAT } from "../../bussines/entities/tipoCambioSUNAT.entity";
import { paramsGetTipoCambioSUNAT } from "../../bussines/params/TipoCambioSUNAT.params";
import { TipoCambioSUNATRepository } from "../../bussines/repository/TipoCambioSUNAT.repository";
import { TipoCambioSUNATExpressProvider } from "../providers/TipoCambioSUNAT.provider";


export class TipoCambioSUNATDatasource implements TipoCambioSUNATRepository {
   private TipoCambioSUNATProvider: TipoCambioSUNATExpressProvider;
   constructor(apiKey: string) {
      this.TipoCambioSUNATProvider = new TipoCambioSUNATExpressProvider(apiKey);
   }
   getTipoCambioSUNAT(variables: paramsGetTipoCambioSUNAT): Promise<TipoCambioSUNAT> {
      return this.TipoCambioSUNATProvider.getTipoCambioSUNAT(variables);
   }
}
